import { ClassAttributes, HTMLAttributes, useContext } from "react";
import TagManager from "react-gtm-module";
import { Interpolation, Theme, css } from "@emotion/react";
import axios from "axios";
import { ContentCardType } from "components/svgs/ContentCardType";
import { ContentTextType } from "components/svgs/ContentTextType";
import { AppContext } from "contexts/AppContext";

export const ContentViewTypePicker = ({
  ...props
}: ClassAttributes<HTMLDivElement> &
  HTMLAttributes<HTMLDivElement> & { css?: Interpolation<Theme> }) => {
  const { contentViewType, setContentViewType } = useContext(AppContext);

  return (
    <div
      css={css`
        display: flex;
        justify-content: flex-end;
        column-gap: 14px;

        & > * {
          cursor: pointer;
        }
      `}
      {...props}
    >
      <ContentCardType
        focused={contentViewType === "card"}
        onClick={() => {
          axios.post("/api/content_view_type", {
            type: "card",
          });
          setContentViewType("card");

          TagManager.dataLayer({
            dataLayer: {
              event: "content_view_type",
              value: "card",
            },
          });
        }}
      />
      <ContentTextType
        focused={contentViewType === "text"}
        onClick={() => {
          axios.post("/api/content_view_type", {
            type: "text",
          });
          setContentViewType("text");

          TagManager.dataLayer({
            dataLayer: {
              event: "content_view_type",
              value: "text",
            },
          });
        }}
      />
    </div>
  );
};
